import { useFileTemporaryLinkMutation } from 'src/data-capture/hooks/useFileTemporaryLinkMutation';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { downloadViaAnchor } from '../utils/downloadViaAnchor';

export function useDownloadDocumentFile(logContext: Record<string, unknown>) {
  const { createLink } = useFileTemporaryLinkMutation();

  const notifyFailure = (e: unknown, fileId: number) =>
    notifyAndLogError(
      'Failed to download document',
      'An error occurred while trying to download the document. Please try again later.',
      e,
      { ...logContext, fileId },
    );

  const downloadFile = async (fileId: number) => {
    try {
      const link = await createLink(fileId);
      window.open(link.url, '_blank');
    } catch (e) {
      notifyFailure(e, fileId);
    }
  };

  const downloadFileViaAnchor = async (fileId: number, fileName?: string) => {
    try {
      await downloadViaAnchor(createLink, fileId, fileName);
    } catch (e) {
      notifyFailure(e, fileId);
    }
  };

  return { downloadFile, downloadFileViaAnchor };
}
